'use strict'

const yItemsLoop = require('../classes/yItemsLoop')

class rmRundownSelector extends yItemsLoop {

    constructor () {
        super()

        this.selectedItems = []
        this.firstSelected = null
        this.yBlocks = null
        this.extraItemData = { 'test': 'dsasad' }
    }

    addBlocks (yBlocks) {
        this.yBlocks = yBlocks
    }

    addDrafts (personal, program, station) {
        if (personal) {
            this.yPersonal = personal
        }

        if (program) {
            this.yProgram = program
        }

        if (station) {
            this.yStation = station
        }
    }

    add (item) {
        if (this.selectedItems.indexOf(item) < 0) {
            // Make sure the element is allowed to be selected
            if (!this.isAllowedToBeSelected(item)) return

            this.selectedItems.push(item)
            this.extraItemData[item.get('id')].selected = true

            if (this.firstSelected == null) {
                this.firstSelected = item
            }
        }
    }

    isAllowedToBeSelected (willSelectItem) {
        if (this.firstSelected) {
            let typeSelected = this.getTypeAndId(this.firstSelected)
            let typeItem = this.getTypeAndId(willSelectItem)

            return typeSelected.type == typeItem.type && typeSelected.id == typeItem.id
        } else {
            return true
        }
    }

    getTypeAndId (item) {
        if (item.get('block_id')) {
            return { type: 'block', id: item.get('block_id') }
        } else if (item.get('user_draft_id')) {
            return { type: 'personal', id: item.get('user_draft_id') }
        } else if (item.get('program_draft_id')) {
            return { type: 'program', id: item.get('program_draft_id') }
        } else if (item.get('station_draft_id')) {
            return { type: 'station', id: item.get('station_draft_id') }
        } else {
            return null
        }
    }

    remove (item) {
        let index = this.selectedItems.indexOf(item)
        if (index > -1) {
            this.selectedItems.splice(index, 1)
            this.extraItemData[item.get('id')].selected = false

            if (this.firstSelected == item) {
                this.getNewFirstSelected()
            }
        }
    }

    toggle (item) {
        if (this.selectedItems.indexOf(item) > -1) {
            this.remove(item)
        } else {
            this.add(item)
        }
    }

    removeAll () {
        for (let i = 0; i < this.selectedItems.length; i++) {
            let item = this.selectedItems[i]
            this.extraItemData[item.get('id')].selected = false
        }
        this.selectedItems = []

        this.firstSelected = null
    }

    getNewFirstSelected () {
        if (this.selectedItems.length > 0) {
            let block = this.yBlocks[(this.selectedItems[0].get('block_id'))]

            if (block) {
                let items = block.get('items').toArray()
                for (let i = 0; items.length; i++) {
                    if (this.selectedItems.indexOf(items[i]) > -1) {
                        this.firstSelected = items[i]
                        return this.firstSelected
                    }
                }
            }
        } else {
            this.firstSelected = null
        }
    }

    indexOf (sought) {
        return this.selectedItems.indexOf(sought)
    }

    indexInBlock (soughtItem) {
        let block = this.yBlocks[soughtItem.get('block_id')]

        if (block) {
            let items = block.get('items').toArray()

            for (let i = 0; items.length; i++) {
                if (soughtItem.get('id') == items[i].get('id')) {
                    return i
                }
            }
            return -1
        }
        return null
    }

    getIndex (item) {
        let typeData = this.getTypeAndId(item)

        if (typeData) {
            let list = this.getListOfType(typeData.type, typeData.id)

            for (let i = 0; i < list.length; i++) {
                if (item.get('id') == list[i].get('id')) {
                    return i
                }
            }
            return -1
        }

        return null
    }

    getListOfType (type, id) {
        switch (type) {

            case('block'):
                const block = this.yBlocks[id]
                if (!block) return []
                return this.getItems(block.get('items'))

            case('personal'):
                return this.getItems(this.yPersonal)

            case('program'):
                return this.getItems(this.yProgram)

            case('station'):
                return this.getItems(this.yStation)

        }
    }

    getHighestSelectedItem () {
        let lowestFound = null
        let lowestFoundIndex = null
        for (let i = 0; i < this.selectedItems.length; i++) {
            let itemOrder = this.selectedItems[i].get('order')
            if (lowestFound == null || itemOrder < lowestFound) {
                lowestFound = itemOrder
                lowestFoundIndex = i
            }
        }

        return this.selectedItems[lowestFoundIndex]
    }

    getSelectedInOrder () {
        return this.selectedItems.sort(function (a, b) {
            let aOrder = a.get('order')
            let bOrder = b.get('order')
            if (aOrder < bOrder)
                return -1
            if (aOrder > bOrder)
                return 1
            return 0
        })
    }

    setDraggingItem () {
        this.draggingItem = this.getHighestSelectedItem()
    }

    removeDraggingItem () {
        this.draggingItem = null
    }
}

rmRundownSelector.$inject = []

module.exports = rmRundownSelector
